import { InAppMessageDelay } from "./InAppMessageDelay"
import { InAppMessageDelayScheduler } from "./InAppMessageDelayScheduler"
import { InAppMessageScheduleRequest } from "../schedule/InAppMessageScheduleRequest"
import Logger from "../../../core/internal/logger"
import { InAppMessageDelayStorage } from "../storage/InAppMessageDelayStorage"
import { InAppMessageDelayTask } from "./InAppMessageDelayTask"

export class InAppMessageDelayManager {
  constructor(
    private readonly scheduler: InAppMessageDelayScheduler,
    private readonly tasks: Map<string, InAppMessageDelayTask>,
    private readonly storage: InAppMessageDelayStorage
  ) {}

  registerAndDelay(request: InAppMessageScheduleRequest): InAppMessageDelay {
    this.storage.set(request.schedule.inAppMessageKey, request.schedule.dispatchId, InAppMessageDelay.from(request))
    return this.delay(request)
  }

  delay(request: InAppMessageScheduleRequest): InAppMessageDelay {
    const delay = InAppMessageDelay.from(request)
    const task = this.scheduler.schedule(delay)
    this.tasks.set(delay.schedule.dispatchId, task)

    Logger.log.debug(`InAppMessage Delay started: dispatchId=${request.schedule.dispatchId}`)
    return delay
  }

  delete(request: InAppMessageScheduleRequest): InAppMessageDelay | null {
    const delay = this.tasks.get(request.schedule.dispatchId)?.delay ?? null
    if (delay) {
      Logger.log.debug(`InAppMessage Delay deleted: dispatchId=${request.schedule.dispatchId}`)
    }

    this.tasks.delete(request.schedule.dispatchId)
    this.storage.remove(request.schedule.inAppMessageKey, request.schedule.dispatchId)
    return delay
  }

  cancelAll(): InAppMessageDelay[] {
    const snapshot = Array.from(this.tasks.values())
    snapshot.forEach((task) => task.cancel())
    this.tasks.clear()
    this.storage.clear()

    Logger.log.debug(`InAppMessage Delay clear.`)

    return snapshot.map((task) => task.delay)
  }
}
